import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09a2f754"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "homepage-welcome",
  class: "h-inherit"
}
const _hoisted_2 = { id: "welcome-info-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-blurb" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "welcome-header highlight-font-size" }, " CARE Behavioral Health "),
  /*#__PURE__*/_createElementVNode("div", { class: "welcome-subheader" }, " Consultative and Professional Development Services ")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "no-wrap-text" }, "can help   >", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_router_link, {
        to: "/services",
        id: "welcome-button",
        class: "button-link"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" See how CARE "),
          _hoisted_4
        ]),
        _: 1
      })
    ])
  ]))
}